module.exports = __webpack_public_path__ + "static/img/4.bb0bafb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/4.png
// module id = iRvI
// module chunks = 1